/** Shared hour/day/week/month filter for Beacon ledger surfaces. */

export type TimeWindow = 'hour' | 'day' | 'week' | 'month' | 'all'

const OPTIONS: { value: TimeWindow; label: string }[] = [
  { value: 'hour', label: 'Hour' },
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'all', label: 'All' },
]

export function TimeWindowFilter({
  value,
  onChange,
}: {
  value: TimeWindow
  onChange: (w: TimeWindow) => void
}) {
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5 text-xs">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={
            value === opt.value
              ? 'rounded-md bg-slate-800 px-3 py-1.5 font-medium text-white'
              : 'rounded-md px-3 py-1.5 text-slate-600 hover:bg-slate-50'
          }
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
